import { backButton, closingBehavior } from '@tma.js/sdk-react'
import { useCallback, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { getTelegramEnv } from './sdk.ts'

export const ROOT_PATHS: ReadonlySet<string> = new Set(['/', '/outbox', '/team', '/more'])

export function isRootPath(pathname: string): boolean {
  return ROOT_PATHS.has(pathname)
}

/** Назад по истории; если истории нет (открыли по ссылке) — на главную. */
export function useGoBack(): () => void {
  const navigate = useNavigate()
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) navigate(-1)
    else navigate('/', { replace: true })
  }, [navigate])
}

/** Telegram BackButton: виден на вложенных экранах, скрыт на корневых. */
export function useTelegramBackButton(): void {
  const { pathname } = useLocation()
  const goBack = useGoBack()
  const goBackRef = useRef(goBack)
  useEffect(() => {
    goBackRef.current = goBack
  })
  const root = isRootPath(pathname)

  useEffect(() => {
    if (!getTelegramEnv().native) return
    try {
      if (root) {
        backButton.hide.ifAvailable()
        return
      }
      backButton.show.ifAvailable()
      if (!backButton.onClick.isAvailable()) return
      return backButton.onClick(() => goBackRef.current())
    } catch {
      return
    }
  }, [root])
}

/** Подтверждение закрытия Mini App, пока есть несохранённые изменения. */
export function useClosingConfirmation(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return
    try {
      closingBehavior.enableConfirmation.ifAvailable()
    } catch {
      // нет поддержки
    }
    const onBeforeUnload = (e: BeforeUnloadEvent): void => {
      e.preventDefault()
    }
    const browser = !getTelegramEnv().native
    if (browser) window.addEventListener('beforeunload', onBeforeUnload)
    return () => {
      try {
        closingBehavior.disableConfirmation.ifAvailable()
      } catch {
        // нет поддержки
      }
      if (browser) window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [enabled])
}
